import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ProjectProvider } from './contexts/ProjectContext';
import { UserProvider } from './contexts/UserContext';
import { authService } from './services/auth';
import LoginPage from './pages/auth/login';
import RegisterPage from './pages/auth/register';
import HomePage from './pages/home';
import RoutingPage from './pages/routing';
import HistoryPage from './pages/history';
import PlaygroundPage from './pages/playground';
import BillingPage from './pages/billing';
import AddCreditsModal from './pages/billing/addCredits';
import AutoTopUpModal from './pages/billing/autoTopUp';
import SettingsPage from './pages/settings';
import ProjectsTab from './pages/settings/ProjectsTab';
import ApiKeysTab from './pages/settings/ApiKeysTab';
import AccountTab from './pages/settings/AccountTab';
import CreateKeyModal from './pages/settings/createKey';
import CreateProjectModal from './pages/settings/createProject';
import ModelsPage from './pages/models';
import DocsPage from './pages/docs';
import EvalsPage from './pages/evals';
import EvalsNewPage from './pages/evalsNew';
import SetupPage from './pages/setup';

function AppRoutes() {
  const [authed, setAuthed] = useState(!!localStorage.getItem('accessToken'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem('accessToken')) {
      setLoading(false);
      return;
    }
    authService.fetchUser(
      () => { setAuthed(true); setLoading(false); },
      () => { localStorage.clear(); setAuthed(false); setLoading(false); }
    );
  }, []);

  if (loading) return null;

  if (!authed) {
    return (
      <Routes>
        <Route path="/login/" element={<LoginPage onLogin={() => setAuthed(true)} />} />
        <Route path="/register/" element={<RegisterPage onRegister={() => setAuthed(true)} />} />
        <Route path="*" element={<Navigate to="/login/" replace />} />
      </Routes>
    );
  }

  return (
    <UserProvider>
      <ProjectProvider>
        <Routes>
          <Route path="/setup/" element={<SetupPage />} />
          <Route path="/setup/project/" element={<SetupPage />} />
          <Route path="/setup/keys/" element={<SetupPage />} />
          <Route path="/setup/integrate/" element={<SetupPage />} />
          <Route path="/setup/integrate/:method/" element={<SetupPage />} />
          <Route path="/setup/test/" element={<SetupPage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/routing/:inputModel/" element={<RoutingPage />} />
          <Route path="/routing/" element={<RoutingPage />} />
          <Route path="/history/" element={<HistoryPage />} />
          <Route path="/history/:eventHash/evals/" element={<HistoryPage />} />
          <Route path="/history/:eventHash/" element={<HistoryPage />} />
          <Route path="/logs/" element={<Navigate to="/history/" replace />} />
          <Route path="/playground/" element={<PlaygroundPage />} />
          <Route path="/evals/new/" element={<EvalsNewPage />} />
          <Route path="/evals/runs/:runId/" element={<EvalsPage />} />
          <Route path="/evals/" element={<EvalsPage />} />
          <Route path="/billing/" element={<BillingPage />}>
            <Route path="add-credits/" element={<AddCreditsModal />} />
            <Route path="auto-top-up/" element={<AutoTopUpModal />} />
          </Route>
          <Route path="/settings/" element={<SettingsPage onLogout={() => setAuthed(false)} />}>
            <Route index element={<Navigate to="projects" replace />} />
            <Route path="projects/" element={<ProjectsTab />}>
              <Route path="new/" element={<CreateProjectModal />} />
            </Route>
            <Route path="keys/" element={<ApiKeysTab />}>
              <Route path="new/" element={<CreateKeyModal />} />
            </Route>
            <Route path="account/" element={<AccountTab />} />
          </Route>
          <Route path="/docs/" element={<DocsPage />} />
          <Route path="/docs/models/" element={<ModelsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ProjectProvider>
    </UserProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
